
<div class="container-fluid mt-5">
    <div class="row">
        <div class="col-md-12">
            <div>
                <h5 id="h5"><i class="fa fa-arrow-circle-left" id="arr"></i>
                    Back</h5>
            </div>
        </div>
    </div>
</div>


<div class="container mt-5">
    <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
            <form class="example">
                <input type="text" placeholder="Search from over 3000 cities...">
                <button type="submit"><i class="fa fa-search"></i></button>
            </form>
            <ul class="list-group list-group-flush">
                <li class="list-group-item"><a href="/customizeuro"><span  id="myDIV">Europe</span>
                <span class="hide" style="float: right;">Start Planning > </span></a></li>
                <li class="list-group-item"><a href="#"><span  id="myDIV">Bali</span>
                <span class="hide" style="float: right;">Start Planning > </span></a></li>
                <li class="list-group-item"><a href="#"><span  id="myDIV">Maldives</span>
                <span class="hide" style="float: right;">Start Planning > </span></a></li>
                <li class="list-group-item"><a href="#"><span  id="myDIV">New Zealand</span>
                <span class="hide" style="float: right;">Start Planning > </span></a></li>
                <li class="list-group-item"><a href="#"><span  id="myDIV">Thailand</span>
                <span class="hide" style="float: right;">Start Planning > </span></a></li>
                <li class="list-group-item"><a href="#"><span  id="myDIV">Australia</span>
                <span class="hide" style="float: right;">Start Planning > </span></a></li>
                <li class="list-group-item"><a href="#"><span  id="myDIV">Thailand</span>
                <span class="hide" style="float: right;">Start Planning > </span></a></li>
                <li class="list-group-item"><a href="#"><span  id="myDIV"></span>
                <span class="hide" style="float: right;"></span></a></li>
              </ul>
        </div>
        <div class="col-md-1"></div>
    </div>
</div>